import { render, staticRenderFns } from "./headerPc.vue?vue&type=template&id=5b8796e4&scoped=true"
import script from "./headerPc.vue?vue&type=script&lang=js"
export * from "./headerPc.vue?vue&type=script&lang=js"
import style0 from "./headerPc.vue?vue&type=style&index=0&id=5b8796e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8796e4",
  null
  
)

export default component.exports